/**
 * The default time interval in secondswhen using using event mode
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_DEFAULT_TIME_INTERVAL = 30;
//# sourceMappingURL=CMCD_DEFAULT_TIME_INTERVAL.js.map